import React from 'react';
import { useLogger } from '@hooks';
import { LoggerConfig } from '@configs';

type TDebugSettings = {
	componentInfo: boolean;
};

export const debugSettingsContext = React.createContext<TDebugSettings>({
	componentInfo: false,
});

export const DebugSettings: React.FC = ({ children }) => {
	const [settings, setSettings] = React.useState<TDebugSettings>({ componentInfo: false });
	const logger = useLogger();
	const debug = LoggerConfig.debug;

	const handleSetting = React.useCallback((setting: keyof TDebugSettings) => {
		setSettings((oldValue) => ({
			...oldValue,
			[setting]: !oldValue[setting],
		}));
	}, []);

	logger('DebugSettings', { settings });

	return (
		<debugSettingsContext.Provider value={settings}>
			{debug && (
				<div
					style={{
						position: 'fixed',
						top: 0,
						left: 'calc(100vw - 200px)',
						backgroundColor: 'grey',
						padding: '10px',
						zIndex: 10000,
					}}
				>
					<div>
						<input
							type="checkbox"
							checked={settings.componentInfo}
							onChange={() => handleSetting('componentInfo')}
						/>
						Component Info
					</div>
				</div>
			)}
			{children}
		</debugSettingsContext.Provider>
	);
};
